import { EditOutlined } from "@ant-design/icons";
import { CorrecaoContabil } from "../../../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import TypeViagem from "../../../../../Models/Domain/Viagem/Viagem";
import { useCorrecaoContabilListarPorViagem } from "../../../../../Services/Domain/Viagem/Financeiro/CorrecaoContabilServices";
import Ordenar from "../../../../../Utils/Ordenacao";
import Utilitario from "../../../../../Utils/Utilitario";
import ResponsiveAntdTable, { ResponsiveAntdTableProps } from "../../../../ResponsiveAntdTable";
import CorrecaoContabilFormModal from "./CorrecaoContabilFormModal";
import CorrecaoContabilDesativarPopConfirm from "./CorrecaoContabilDesativarPopConfirm";
import { Flex } from "antd";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { extractorNomePessoa } from "../../../../../Models/Pessoa/Pessoa";

export interface ICorrecaoContabilTablePorViagemProps extends ResponsiveAntdTableProps<CorrecaoContabil> {
    viagem:TypeViagem;
}
export default function CorrecaoContabilTablePorViagem({
    viagem,
    columns,
    ...props
}:ICorrecaoContabilTablePorViagemProps) {
    const {
        data,
        isLoading
    } = useCorrecaoContabilListarPorViagem({
        codViagem : viagem.codigo ?? -1
    });

    return <ResponsiveAntdTable<CorrecaoContabil>
        bordered
        locale={{ emptyText: 'Nenhum ajuste encontrado.' }}
        dataSource={data}
        loading={isLoading}
        rowKey={(k) => k.codigo}
        addTitleOn="lg"
        columns={[
            {
                title: "Beneficiário",
                dataIndex: ["beneficiario", "nome"],
                render: (value: string, record:CorrecaoContabil) => extractorNomePessoa(record.beneficiario!),
                key: 50,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 6 }
            },
            {
                title: "Plano de contas",
                dataIndex: ["planoContas", "descricao"],
                key: 50,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 6 }
            },
            {
                title: "Pagamento",
                dataIndex: "dataPagamento",
                render: (value: Date) => value.toLocaleDateString(),
                sorter: (ajuste1:CorrecaoContabil, ajuste2:CorrecaoContabil) => Ordenar.Data(ajuste1.dataPagamento, ajuste2.dataPagamento),
                key: 52,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 3, xxl : 3 }
            },
            {
                title: "Valor",
                dataIndex: "valor",
                render: (value: number) => Utilitario.toStringDinheiro(value),
                sorter: (ajuste1:CorrecaoContabil, ajuste2:CorrecaoContabil) => Ordenar.Numero(ajuste1.valor, ajuste2.valor),
                key: 53,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 3, xxl : 3 }
            },
            {
                title: "Comprovante",
                dataIndex: ["comprovante"],
                render(value:string, record:CorrecaoContabil) {
                    return (record.urlComprovante ?? '').length > 0 ? <a rel="noopener" href={record.urlComprovante!} target="_blank">{value}</a> : value;
                },
                key: 54,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 3, xxl : 3 }
            },
            {
                title : "Ações",
                dataIndex : ["codigo"],
                render(value:number, record:CorrecaoContabil) {
                    return <Flex gap={8} wrap="wrap">
                        <ComponentePermissao permissoes={["ViagemFinanceiroCorrecaoContabilAlterar"]}>
                            <CorrecaoContabilFormModal
                                destroyOnClose={true}
                                correcaoContabil={record}
                                textButtonOpen={<EditOutlined />}
                                propsButtonOpen={{
                                    type : "dashed",
                                    title : "Editar"
                                }}
                            />
                        </ComponentePermissao>
                        <ComponentePermissao permissoes={["ViagemFinanceiroCorrecaoContabilDesativar"]}>
                            <CorrecaoContabilDesativarPopConfirm
                                correcaoContabil={record}
                                buttonProps={{
                                    title : "Remover"
                                }}
                            />
                        </ComponentePermissao>
                    </Flex>;
                },
                key : 55,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 3, xxl : 3 }
            },
            ...(columns ?? [])
        ].sort((coluna1, coluna2) => Ordenar.Numero(Number(coluna1.key), Number(coluna2.key)))}
        {...props}
    />
}